import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import "./Layout.css";

const Layout = ({ children, name }) => {
  return (
    <div className="layout">
      <Header />
      {!name ? (
        <div className="layout-container">
          <Sidebar />
          <div className="children">
            {children}
          </div>
        </div>
      ) : (
        <div className="children">
          {children}
        </div>
      )}
    </div>
  );
};

export default Layout;